import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { Pets } from '../types';

export type requestDTO = {
  petId: string;
  parentId: string;
};

export const getPet = ({ petId, parentId }: requestDTO): Promise<Pets> => {
  return axios.get(`/business/parent/${parentId}/pet/${petId}`);
};

type UsePetOptions = {
  config?: MutationConfig<typeof getPet>;
};

export const useGetPet = ({ config }: UsePetOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getPet,
  });
};
